import { render } from "./RegisteredProgram.vue?vue&type=template&id=30fb5a2c&scoped=true"
import script from "./RegisteredProgram.vue?vue&type=script&lang=js"
export * from "./RegisteredProgram.vue?vue&type=script&lang=js"

import "./RegisteredProgram.vue?vue&type=style&index=0&id=30fb5a2c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30fb5a2c"]])

export default __exports__